module.exports = __webpack_public_path__ + "static/media/Apple Watch 40mm Titanium + Red Closed.a0b8b53c.png";